import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';

const PRODUCT_TYPES = {
  goods: 'GOODS',
  program: 'PROGRAM',
  service: 'SERVICE',
} as const;

export const productTypeFilterConfig = createSimpleFilterConfig({
  facetName: 'type',
  options: Object.values(PRODUCT_TYPES).map((type) => ({
    label: formatTextForDisplay(type),
    value: type,
  })),
});
